import {SVGProps} from 'react';

export const DropboxOSLine = (props: SVGProps<SVGSVGElement>): React.ReactElement => {
  const iconFill = 'currentColor';
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
      <g transform="translate(4 4) scale(0.9187) translate(-9.44147 -7.29236)">
        <path
          d="M15.1769 13.0222H21.1274C21.0863 9.32632 19.0168 7.29236 15.2854 7.29236C11.5539 7.29236 9.44147 9.36745 9.44147 13.1363C9.44147 16.9051 11.4773 18.9372 15.1751 18.9783V13.0241H15.1769V13.0222Z"
          fill={iconFill}
        />
        <path
          d="M21.1125 13.024V18.9745H15.1583C15.1994 22.6723 17.2689 24.7081 21.0003 24.7081C24.7317 24.7081 26.8442 22.633 26.8442 18.8642C26.8442 15.0954 24.8102 13.0652 21.1143 13.0222H21.1125V13.024Z"
          fill={iconFill}
        />
      </g>
    </svg>
  );
};
